export default __webpack_public_path__ + "a8dd898f3db016cf3442b3d63265cd66.png";